__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "reports-main";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@mui/material", "7.3.4", () => (Promise.all([__webpack_require__.e(138), __webpack_require__.e(213), __webpack_require__.e(112), __webpack_require__.e(85)]).then(() => (() => (__webpack_require__(1138))))));
			register("@reduxjs/toolkit", "2.9.0", () => (Promise.all([__webpack_require__.e(939), __webpack_require__.e(57)]).then(() => (() => (__webpack_require__(3939))))));
			register("darkreader", "4.9.117", () => (__webpack_require__.e(736).then(() => (() => (__webpack_require__(736))))));
			register("react-dom", "19.1.1", () => (() => (__webpack_require__(3144))), 1);
			register("react-error-boundary", "6.0.0", () => (__webpack_require__.e(938).then(() => (() => (__webpack_require__(938))))));
			register("react-redux", "9.2.0", () => (__webpack_require__.e(541).then(() => (() => (__webpack_require__(541))))));
			register("react-router", "7.12.0", () => (__webpack_require__.e(768).then(() => (() => (__webpack_require__(3768))))));
			register("react-toastify", "11.0.5", () => (__webpack_require__.e(30).then(() => (() => (__webpack_require__(1030))))));
			register("react", "19.1.1", () => (() => (__webpack_require__(4041))), 1);
			register("zeron-ui", "6.2.0", () => (Promise.all([__webpack_require__.e(16), __webpack_require__.e(112)]).then(() => (() => (__webpack_require__(7016))))));
			initExternal(3430);
			initExternal(1554);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};